var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"collections-data-sources"},[_c('TextTitle',{attrs:{"size":"s","weight":"bold"}},[_vm._v(_vm._s(_vm.$t('collections.parameters')))]),_c('CollectionsDataSourcesSelector',{on:{"change":_vm.catalogueCollectionUpdateStateSource}}),_c('CollectionsDataSourcesConditions')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }